t = require('app/scripts/views/internal/teacup-with-helpers')('member')

module.exports = t.renderable ({ avatarUrl, viewTitle, initials, isDeactivated, isBoardAdmin, isOrganizationAdmin }) ->
  title = viewTitle
  if avatarUrl
    avatarUrl1x = [avatarUrl, '30.png'].join('/')
    avatarUrl2x = [avatarUrl, '50.png'].join('/')
    t.img {
      class: 'member-avatar'
      height: '30'
      width: '30'
      src: avatarUrl1x
      srcset: "#{avatarUrl1x} 1x, #{avatarUrl2x} 2x"
      alt: title
      title
    }

  else if initials
    t.span '.member-initials', { title, 'aria-label': title }, ->
      t.text initials
  else
    t.div '.member-icon-container', ->
      t.icon 'member'

  if !isDeactivated
    if isBoardAdmin
      t.span '.member-type.admin', { title: t.l('this-member-is-an-admin-of-this-board') }
    if isOrganizationAdmin
      t.span '.member-type.admin', { title: t.l('this-member-is-an-admin-of-this-organization') }

  t.span '.member-gold-badge', { title: t.l('this-member-has-trello-gold') }